class HHVariantPicker extends HTMLElement {
  constructor() {
    super()

    this.mainProduct = this.closest(`#ProductInfo-${this.dataset.section}`)
    this.addEventListener('change', this.onVariantChange)
    this.adjustOptions()

    this.variantToMediaMap = this.parseVariantMediaMapping()
    console.log('Variant to Media Map:', this.variantToMediaMap)
    this.variantMetafields = this.parseVariantMetafields()

    window.addEventListener('load', () => {
      this.updateEngravingLimits()
    })
  }

  connectedCallback() {
    const selectedVariantId = this.getSelectedVariantIdFromURL()
    if (selectedVariantId) {
      this.currentVariant = this.getVariantData().find(
        (v) => v.id == selectedVariantId
      )
      if (this.currentVariant && this.currentVariant.featured_media) {
        const mediaId = this.variantToMediaMap[this.currentVariant.id]
        this.reorderSliderForVariant(mediaId)
      }
    }
  }

  parseVariantMetafields() {
    const metafieldDataContainer = document.getElementById(
      'variant-engraving-data'
    )
    return metafieldDataContainer
      ? JSON.parse(
          metafieldDataContainer.getAttribute('data-variant-metafields')
        )
      : {}
  }

  parseVariantMediaMapping() {
    const mappingScript = this.querySelector('script[type="application/json"]')
    if (!mappingScript) return {}

    try {
      const mappings = JSON.parse(mappingScript.textContent)
      const variantToMedia = {}
      mappings.forEach((variant) => {
        if (variant.featured_media && variant.id) {
          variantToMedia[variant.id] = variant.featured_media.id
        }
      })
      return variantToMedia
    } catch (error) {
      console.error('Error parsing variant to media mapping:', error)
      return {}
    }
  }

  onVariantChange(e) {
    if (
      e.target.classList.contains('engraving-input--text') ||
      e.target.classList.contains('engraving-input--text-optional') ||
      e.target.getAttribute('id') === 'additional_monogram'
    ) {
      return true
    }

    // Hide the limit span before making changes
    const limitSpan = document.querySelector('.engraving-input__text-limit')
    if (limitSpan) {
      limitSpan.style.display = 'none'
    }

    this.initEngraving(e)
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    if (window.location.hostname !== '127.0.0.1')
      this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }

    this.updateEngravingLimits()

    if (!this.currentVariant) {
      console.log('No variant selected.')
      return
    }

    console.log('Selected variant:', this.currentVariant)

    if (this.currentVariant.featured_media) {
      const mediaId = this.variantToMediaMap[this.currentVariant.id]
      console.log('Attempting to find and reorder slide for media ID:', mediaId)

      this.reorderSliderForVariant(mediaId)
    } else {
      console.log('No featured media for the selected variant.')
    }

    setTimeout(() => {
      this.updateButtonPrice()
    }, 1)
  }

  updateButtonPrice() {
    const priceElement = document.querySelector('.product-block__price .price')
    if (priceElement) {
      const button = document.getElementById('spaced-button')
      if (button) {
        button.innerHTML = `
          <div>
            Add to cart
          </div>
          <div class="no-js-hidden" data-render>
            ${priceElement.outerHTML}
          </div>
        `
        button.classList.remove('hidden')
        button.disabled = false
      } else {
        // console.log('Button with ID "spaced-button" not found')
      }
    } else {
      // console.log('Price element not found')
    }
  }

  updateEngravingLimits() {
    setTimeout(() => {
      const input = document.querySelector(
        '.engraving-input__text .field__input'
      )
      const limitSpan = document.querySelector('.engraving-input__text-limit')
      const variantId = new URLSearchParams(window.location.search).get(
        'variant'
      )

      if (variantId && this.variantMetafields) {
        const variantData = this.variantMetafields.find(
          (v) => v.id === variantId
        )
        if (variantData && variantData.engraving_character_limit_variant) {
          console.log(
            `Updating engraving limit to ${variantData.engraving_character_limit_variant}`
          )
          input.setAttribute(
            'maxlength',
            variantData.engraving_character_limit_variant
          )
          console.log('ratatata')
          limitSpan.textContent = `${variantData.engraving_character_limit_variant} Character Limit`
        } else {
          console.log(
            `No specific engraving limit provided for variant ${variantId}, using default.`
          )
        }
      } else {
        console.log('No variant ID found in URL or engraving data missing.')
      }

      limitSpan.style.display = 'block'
    }, 1000) // Delay might need to be adjusted depending on how long other scripts take
  }

  reorderSliderForVariant(mediaId) {
    const slider = document.querySelector('hh-slider')
    if (!slider) {
      console.log('Slider element not found.')
      return
    }

    const targetSlide = slider.querySelector(`[media-id="${mediaId}"]`)
    if (!targetSlide) {
      console.log('No matching slide found for media ID:', mediaId)
      return
    }

    console.log('Matching slide found, reordering...')
    slider.insertBefore(targetSlide, slider.firstChild)
    console.log('Slide for media ID:', mediaId, 'moved to the top.')

    if (typeof slider.refreshItems === 'function') {
      slider.refreshItems()
    }

    setTimeout(() => {
      // Assuming the reordered slide is now the first one, scroll to index 0
      const indexToScrollTo = 0
      const scrollEvent = new CustomEvent('hh-slider:scroll-to', {
        detail: { index: indexToScrollTo },
        bubbles: true,
        composed: true,
      })
      slider.dispatchEvent(scrollEvent)
      console.log(
        `Dispatched custom event to scroll to slide index ${indexToScrollTo}`
      )
    }, 10)
  }

  initEngraving(e) {
    if (e.target.classList.contains('is-engraving-dropdown')) {
      const gallery = document.querySelector('.js-product-gallery')
      const engravingImage = [...gallery.querySelectorAll('.img img')].find(
        (img) => img.getAttribute('alt').toLowerCase().includes('engraving')
      )
      const engravingImageWrapper = engravingImage?.closest(
        '.js-thumbnail-wrapper'
      )
      if (engravingImageWrapper) {
        const textItem = engravingImageWrapper.querySelector(
          '.js-engraving-viewbox text'
        )
        if (textItem) {
          textItem.removeAttribute('x')
          textItem.removeAttribute('y')
          textItem.removeAttribute('font-size')
          textItem.innerHTML = ''
        }
      }
    }
  }

  adjustOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll('.vp__input--button, .js-dropdown-input')
    )
    if (fieldsets.length > 1) {
      const firstOption = this.getFieldsetValue(fieldsets[0])
      fieldsets.forEach((fieldset, index) => {
        if (index !== 0) {
          const availableOptions = this.getIndexOptionsByFirst(
            firstOption,
            index
          )
          fieldset.querySelectorAll('input').forEach((input) => {
            if (availableOptions.includes(input.value)) {
              input.classList.remove('disabled')
            } else {
              input.checked = false
              input.classList.add('disabled')
            }
          })

          if (
            fieldset.querySelectorAll('input:checked').length == 0 &&
            fieldset.querySelector('input:not(.disabled)')
          ) {
            fieldset.querySelector('input:not(.disabled)').checked = true
          }
        }
      })
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll('.vp__input--button, .js-dropdown-input')
    )
    if (fieldsets && fieldsets.length) {
      this.adjustOptions()
      this.options = fieldsets.map((fieldset) => {
        return this.getFieldsetValue(fieldset)
      })
    }
  }

  getFieldsetValue(fieldset) {
    if (fieldset.classList.contains('vp__input--button')) {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    } else {
      return fieldset.querySelector('input')?.value
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    )
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        this._replaceProductInfo(responseText)
      })
  }

  _replaceProductInfo(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destinations = this.mainProduct.querySelectorAll('[data-render]')
    const sources = html.querySelectorAll('[data-render]')

    destinations.forEach((destination, index) => {
      destination.innerHTML = sources[index]?.innerHTML
      destination.classList.remove('visibility-hidden')
    })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      addButton.classList.add('hidden')
      if (text) addButton.textContent = text
      this.mainProduct
        .querySelector('.product-block__price .price')
        .classList.add('visibility-hidden')
    } else {
      addButton.removeAttribute('disabled')
      addButton.classList.remove('hidden')
      addButton.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    addButton.classList.add('hidden')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getIndexOptionsByFirst(firstOption, index) {
    return this.getVariantData().map((variant) => {
      return variant.options[0] == firstOption ? variant.options[index] : ''
    })
  }

  getSelectedVariantIdFromURL() {
    const params = new URLSearchParams(window.location.search)
    return params.get('variant')
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
